import { render } from "./Progetti.vue?vue&type=template&id=791e8d7d&scoped=true"
import script from "./Progetti.vue?vue&type=script&lang=js"
export * from "./Progetti.vue?vue&type=script&lang=js"

import "./Progetti.vue?vue&type=style&index=0&id=791e8d7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791e8d7d"]])

export default __exports__